import { Table } from '@tanstack/react-table';
// import { DataTableFacetedFilter } from 'components/blocks/data-table/data-table-faceted-filter';
import { DateRangeFilter } from 'components/blocks/data-table/data-table-date-filter';
// import { statuses } from './organization-table-filter-data';
import { DateRange } from 'react-day-picker';
import { useTranslation } from 'react-i18next';

interface FilterControlsProps<TData> {
    table: Table<TData>;
    isMobile?: boolean;
    dateRangeCreate?: DateRange;
    onDateRangeCreateChange?: (date: DateRange | undefined) => void;
}

export function FilterControls<TData>({
    table,
    isMobile = false,
    dateRangeCreate,
    onDateRangeCreateChange = () => void 0,
}: Readonly<FilterControlsProps<TData>>) {
    const { t } = useTranslation();

    const getFilterColumn = (columnId: string) => {
        return table.getAllFlatColumns().find((col) => col.id === columnId);
    };

    const containerClass = isMobile
        ? 'flex flex-col space-y-4'
        : 'flex flex-row flex-wrap items-center gap-1';

    //const activeColumn = getFilterColumn('isActive');
    const createdDateColumn = getFilterColumn('createdDate');

    return (
        <div className={containerClass}>
            {/* {activeColumn && (
                <div className={isMobile ? 'w-full' : undefined}>
                    <DataTableFacetedFilter column={activeColumn} title={t('STATUS')} options={statuses} />
                </div>
            )} */}

            {createdDateColumn && (
                <div className={isMobile ? 'w-full' : undefined}>
                    <DateRangeFilter
                        column={createdDateColumn}
                        title={t('CREATED_ON')}
                        date={dateRangeCreate}
                        onDateChange={onDateRangeCreateChange}
                    />
                </div>
            )}
        </div>
    );
}

export default FilterControls; 